import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {gqlPayment} from './getPayment.api';
import {Payment} from '../../graphql/payments.datatypes';

interface PaymentsData {
    payments: void,
    paymentsWithGroupMemberPaymentsOfType: void,
    paymentsInMyGroup: {
        data: Payment[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_PAYMENTS_QUERY = gql`
  query paymentsInMyGroup($groupRef: String!, $billingPartyId: Int!, $count: Int!, $page: Int!, $where: WhereConditions, $hasBillingPartyMember: QueryPaymentsInMyGroupHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    paymentsInMyGroup(groupRef: $groupRef, billingPartyId: $billingPartyId, first: $count, page: $page, where: $where, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      data {
        ${gqlPayment}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getPaymentsInMyGroup = (groupRef: string, billingPartyId: number, count: number, page: number, where?: any, orderBy?: any, hasBillingPartyMember?: any) => useQuery<PaymentsData>(
    GET_PAYMENTS_QUERY,
    {
        variables: {
            groupRef,
            billingPartyId,
            count,
            page,
            where,
            hasBillingPartyMember,
            orderBy,
        },

    }
);

export default getPaymentsInMyGroup;
